var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personnel-education"},[_c('personnel_scout',{attrs:{"editpersonnel_temporary":{ id_card: _vm.editpersonnel_temporary.id_card, },"source-type":"self"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }